/* Tasje block in the V2 buy box (snippets/swubie-buybox-nudge.liquid, offer test A).
   A card with a gift (data-gift-variant, the 2+1) selected: the block shows the free tasje as included and its box is
   unticked and locked, because swubie-lp.js adds the gift line itself. Any other card: the box is the paid add-on again,
   with the choice the shopper made before. The button total is swubie-addon.js (change event). */
(function () {
  document.querySelectorAll('[data-swb-nudge]').forEach(function (el) {
    if (el.getAttribute('data-ready-nudge')) return;
    el.setAttribute('data-ready-nudge', '1');
    var root = el.closest('.shopify-section') || document;
    var cb = el.querySelector('.swb-nudge__input');
    var wanted = false;
    function sync() {
      var sel = root.querySelector('.slp-bundle.selected');
      var gift = !!(sel && sel.getAttribute('data-gift-variant'));
      if (gift === el.classList.contains('is-included')) return;
      el.classList.toggle('is-included', gift);
      if (gift) { wanted = cb.checked; cb.checked = false; cb.disabled = true; }
      else { cb.disabled = false; cb.checked = wanted; }
      cb.dispatchEvent(new Event('change'));
    }
    root.querySelectorAll('.slp-bundle').forEach(function (b) {
      new MutationObserver(sync).observe(b, { attributes: true, attributeFilter: ['class'] });
    });
    sync();
  });
})();
